import { shape, string } from 'prop-types';
import qs from 'query-string';
import React from 'react';
import { Link } from 'react-router-dom';
import { Alert } from 'reactstrap';

import ErrorComponent from '../../generic/Error';
import api from '../../REST/api';
import permissions from '../../utils/permissions';
import * as Session from '../../utils/session';
import Layout from './Layout';

const unknownLoginErrorMessage =
  "It looks like you tried to login but we can not confirm that was successful, and don't have an error response either. Please try again, and contact support if this keeps happening.";

async function loadCurrentUser() {
  const user = await api.getCurrentUser();
  Session.write({ user });
  return user;
}

async function loadUserPermissions(user) {
  const rules = await api.getUserPermissions({ id: user.id });
  permissions.set(rules);
  return permissions;
}

function closeWindow() {
  window.close();
}

class Authorized extends React.Component {
  constructor(props) {
    super(props);

    this.state = { error: null };

    this.setError = this.setError.bind(this);
  }

  componentDidMount() {
    const { location } = this.props;

    // The OAuth flow redirects back to this location,
    // passing the access token in the hash on success.
    const { access_token: token, error } = qs.parse(location.hash);

    if (token) {
      Session.write({ token });

      loadCurrentUser()
        .then(loadUserPermissions)
        .then(closeWindow)
        .catch(this.setError);
    } else if (error) {
      this.setError(new Error(error));
    } else {
      this.setError(new Error(unknownLoginErrorMessage));
    }
  }

  setError(error) {
    const clonableError = { message: error.message };

    if (error.request) {
      clonableError.request = { data: error.request.data };
    }

    this.setState({ error: clonableError });
  }

  render() {
    const { error } = this.state;

    if (error) {
      return (
        <Layout>
          <ErrorComponent error={error} />
          <div className="text-center">
            <Link
              to="/login/start"
              push={false}
              className="btn btn-primary mt-3"
            >
              Retry
            </Link>
          </div>
        </Layout>
      );
    }

    return (
      <Layout>
        <Alert color="light">Fetching your account information…</Alert>
      </Layout>
    );
  }
}

Authorized.propTypes = {
  location: shape({ hash: string }).isRequired,
};

export default Authorized;
